/* =========================================
   REFINE BUILDER - MASTER JAVASCRIPT
========================================= */

let nikkahBundleItems = [];
let nikkahFormatMoney = (amount) => 'Rs ' + (amount / 100).toFixed(0);

function getBundleConfig(element) {
  let container = element ? element.closest('.nikkah-bundle-container') : null;
  if(!container) container = document.querySelector('.nikkah-bundle-container');
  return {
    id: container ? container.getAttribute('data-section-id') : '',
    themeColor: container ? container.getAttribute('data-theme-color') : '#000',
    minItems: container ? parseInt(container.getAttribute('data-min-items')) : 1,
    freeShippingGoal: container ? parseFloat(container.getAttribute('data-free-shipping-goal')) || 0 : 0,
    successMsg: container ? container.getAttribute('data-success-msg') : '',
    initialMsg: container ? container.getAttribute('data-initial-msg') : '',
    discountCode: container ? container.getAttribute('data-discount-code') : ''
  };
}

function toggleMobileCart() {
  let sidebar = document.getElementById('bundle-sticky-sidebar');
  if(!sidebar) sidebar = document.querySelector('.rb-sidebar-drawer');
  if(sidebar) sidebar.classList.toggle('cart-active');
}

function openTab(evt, tabId) {
  let config = getBundleConfig(evt.currentTarget);
  let container = document.getElementById('bundle-builder-' + config.id);
  if(!container) return;
  let tabcontent = container.getElementsByClassName("tab-content");
  let tablinks = container.getElementsByClassName("bundle-tab-btn");
  let targetTab = document.getElementById(tabId);
  for (let i = 0; i < tablinks.length; i++) tablinks[i].classList.remove("active");
  evt.currentTarget.classList.add("active");
  for (let i = 0; i < tabcontent.length; i++) tabcontent[i].classList.remove("active");
  targetTab.classList.add("active");
}

function loadMoreProducts(gridId, btnElement, count) {
  let grid = document.getElementById(gridId);
  if(!grid) return;
  let hiddenCards = grid.querySelectorAll('.hidden-card');
  for(let i = 0; i < count && i < hiddenCards.length; i++) hiddenCards[i].classList.remove('hidden-card');
  if(grid.querySelectorAll('.hidden-card').length === 0) btnElement.style.display = 'none';
}

function addToBundle(btn, productTitle, requiresFields) {
  try {
    let config = getBundleConfig(btn);
    let card = btn.closest('.product-card');
    let select = card.querySelector('.variant-selector');
    
    if (!select) return;

    let variantId = select.value;
    let variantTitle = '';
    let price = 0;

    if (select.tagName === 'SELECT') {
      variantTitle = select.options[select.selectedIndex].text;
      let priceAttr = select.options[select.selectedIndex].getAttribute('data-price');
      price = parseInt(priceAttr) || 0;
    } else {
      variantTitle = '';
      let priceAttr = select.getAttribute('data-price');
      price = parseInt(priceAttr) || 0;
    }

// Card se image ka URL nikaalna
    let imgElement = card.querySelector('.bundle-product-image');
    let imageUrl = imgElement ? imgElement.src : '';

    nikkahBundleItems.push({ 
      id: variantId, 
      title: productTitle, 
      variantTitle: variantTitle, 
      price: price, 
      image: imageUrl, // <--- Image thumbnail yahan save ho rahi hai
      requiresFields: requiresFields, 
      showDetails: false, 
      groom: '', 
      bride: '', 
      date: '', 
      note: '' 
    });

    updateSidebar(config);
    
    let originalText = btn.innerText;
    btn.innerText = "✓ Added";
    btn.style.background = config.themeColor; 
    btn.style.color = "#fff";
    setTimeout(() => { 
      btn.innerText = originalText; 
      btn.style.background = "transparent"; 
      btn.style.color = config.themeColor; 
    }, 1000);
  } catch(e) { 
    console.error("Add to bundle error:", e); 
  }
}

function removeFromBundle(index, element) { 
  let config = getBundleConfig(element); 
  nikkahBundleItems.splice(index, 1); 
  updateSidebar(config); 
}

function updateItemData(index, field, value) { 
  if(nikkahBundleItems[index]) {
    nikkahBundleItems[index][field] = value; 
  }
}

function toggleDetails(index) {
  nikkahBundleItems[index].showDetails = !nikkahBundleItems[index].showDetails;
  let detailsDiv = document.getElementById('details-' + index);
  let iconSpan = document.getElementById('icon-' + index);
  if(detailsDiv) detailsDiv.style.display = nikkahBundleItems[index].showDetails ? 'block' : 'none';
  if(iconSpan) iconSpan.innerText = nikkahBundleItems[index].showDetails ? '−' : '+';
}

function updateSidebar(config) {
  if(!config) config = getBundleConfig();
  
  let listContainer = document.getElementById('selected-items-list');
  if(!listContainer) listContainer = document.querySelector('.rb-items-list');

  let totalContainer = document.getElementById('bundle-total-price');
  if(!totalContainer) totalContainer = document.querySelector('.rb-total-price');

  let originalPriceContainer = document.getElementById('bundle-original-price');
  let discountRow = document.getElementById('discount-row');
  let discountAmountContainer = document.getElementById('bundle-discount-amount');

  let checkoutBtn = document.getElementById('add-to-cart-btn');
  if(!checkoutBtn) checkoutBtn = document.querySelector('.rb-checkout-btn');

  let progressFill = document.getElementById('progress-fill');
  if(!progressFill) progressFill = document.querySelector('.rb-progress-fill');

  let discountText = document.getElementById('discount-text');
  if(!discountText) discountText = document.querySelector('.rb-discount-text');

  let freeShippingText = document.getElementById('free-shipping-text');
  
  let mobileCount = document.getElementById('mobile-floater-count');
  if(!mobileCount) mobileCount = document.querySelector('.rb-mobile-count');

  let mobileTotal = document.getElementById('mobile-floater-total');
  if(!mobileTotal) mobileTotal = document.querySelector('.rb-mobile-total');
  
  if(listContainer) listContainer.innerHTML = '';
  let totalPrice = 0;

  if (nikkahBundleItems.length === 0) {
    if(listContainer) {
      listContainer.innerHTML = `<div style="text-align: center; padding: 30px 0;"><svg style="width: 50px; height: 50px; color: #ddd; margin-bottom: 10px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path></svg><p style="color: #999; font-size: 14px; margin: 0;">Your package is empty.<br>Select items from the left to begin.</p></div>`;
    }
    if(checkoutBtn) checkoutBtn.disabled = true; 
    if(progressFill) progressFill.style.width = '0%'; 
    if(discountText) discountText.innerText = config.initialMsg;
    if(freeShippingText) freeShippingText.innerText = "";
    if(originalPriceContainer) originalPriceContainer.innerText = "Rs 0";
    if(totalContainer) totalContainer.innerText = "Rs 0";
    if(discountRow) discountRow.style.display = 'none';
    if(mobileCount) mobileCount.innerText = "0 Items";
    if(mobileTotal) mobileTotal.innerText = "Rs 0";
    return;
  } else {
    nikkahBundleItems.forEach((item, index) => {
      totalPrice += item.price;
      let customFieldsHTML = item.requiresFields ? `
          <div style="background: #f9fafb; border: 1px solid #eee; border-radius: 6px; overflow: hidden; margin-top: 5px;">
            <div onclick="toggleDetails(${index})" style="padding: 8px 10px; font-size: 12px; font-weight: 600; color: ${config.themeColor}; cursor: pointer; display: flex; justify-content: space-between;">
              <span>✎ Add Custom Details</span><span id="icon-${index}">${item.showDetails ? '−' : '+'}</span>
            </div>
            <div id="details-${index}" style="display: ${item.showDetails ? 'block' : 'none'}; padding: 0 10px 10px; border-top: 1px solid #eee;">
              <input type="text" placeholder="Groom's Name" value="${item.groom||''}" oninput="updateItemData(${index}, 'groom', this.value)" style="width: 100%; padding: 8px; margin-top: 10px; font-size: 12px; border: 1px solid #ddd; border-radius: 4px;">
              <input type="text" placeholder="Bride's Name" value="${item.bride||''}" oninput="updateItemData(${index}, 'bride', this.value)" style="width: 100%; padding: 8px; margin-top: 8px; font-size: 12px; border: 1px solid #ddd; border-radius: 4px;">
              <div style="margin-top: 8px;">
                <label style="font-size: 11px; color: #777; display: block; margin-bottom: 2px;">Nikkah / Event Date</label>
                <input type="date" value="${item.date||''}" oninput="updateItemData(${index}, 'date', this.value)" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box; outline: none; font-size: 12px; color: #333;">
              </div>
              <textarea placeholder="Instructions?" oninput="updateItemData(${index}, 'note', this.value)" style="width: 100%; padding: 8px; margin-top: 8px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box; outline: none;" rows="2">${item.note||''}</textarea>
            </div>
          </div>` : '';

      if(listContainer) {
        listContainer.innerHTML += `
          <div class="sidebar-item" style="padding: 12px 0; border-bottom: 1px dashed #eee; font-size: 14px;">
            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 5px; gap: 10px;">
              <img src="${item.image || ''}" alt="${item.title}" style="width: 45px; height: 45px; object-fit: cover; border-radius: 6px; border: 1px solid #eee; flex-shrink: 0;">
              
              <div style="flex-grow: 1; line-height: 1.3;"><strong style="color: #222;">${item.title}</strong><br><span style="font-size: 12px; color: #777;">${item.variantTitle}</span></div>
              <div style="display: flex; align-items: center; gap: 8px;"><span style="font-weight: bold; color: #444; font-size: 13px;">${nikkahFormatMoney(item.price)}</span><span class="remove-item" onclick="removeFromBundle(${index}, this)" style="background: #fee2e2; color: #ef4444; width: 22px; height: 22px; display: inline-flex; align-items: center; justify-content: center; border-radius: 50%; cursor: pointer; font-size: 11px; font-weight: bold;">✕</span></div>
            </div>${customFieldsHTML}
          </div>`;
      }
    });
    
    if(checkoutBtn) checkoutBtn.disabled = false;
    
    // Automatic 15% Discount Calculation
    let discountAmount = 0;
    let finalTotalPrice = totalPrice;

    if (nikkahBundleItems.length >= config.minItems) {
      discountAmount = totalPrice * 0.15; 
      finalTotalPrice = totalPrice - discountAmount;

      if(progressFill) { progressFill.style.width = '100%'; progressFill.style.background = '#10b981'; }
      if(discountText) { discountText.innerText = config.successMsg; discountText.style.color = '#10b981'; }
      if(discountRow) discountRow.style.display = 'flex';
      if(discountAmountContainer) discountAmountContainer.innerText = '-' + nikkahFormatMoney(discountAmount);
    } else {
      let needed = config.minItems - nikkahBundleItems.length;
      if(progressFill) { progressFill.style.width = (nikkahBundleItems.length / config.minItems * 100) + '%'; progressFill.style.background = config.themeColor; }
      if(discountText) { discountText.innerText = `Add ${needed} more item(s) to unlock discount!`; discountText.style.color = config.themeColor; }
      if(discountRow) discountRow.style.display = 'none';
    }

    if(originalPriceContainer) originalPriceContainer.innerText = nikkahFormatMoney(totalPrice);
    if(totalContainer) totalContainer.innerText = nikkahFormatMoney(finalTotalPrice);
    if(mobileCount) mobileCount.innerText = nikkahBundleItems.length + " Items";
    if(mobileTotal) mobileTotal.innerText = nikkahFormatMoney(finalTotalPrice);

    // Free Shipping Progress Bar Calculation
    if (config.freeShippingGoal > 0) {
      let goalCents = config.freeShippingGoal * 100;
      if (finalTotalPrice >= goalCents) {
        if(freeShippingText) freeShippingText.innerHTML = "🚚 <span style='color: #10b981; font-weight: bold;'>Free Delivery Unlocked!</span>";
      } else {
        let diff = goalCents - finalTotalPrice;
        if(freeShippingText) freeShippingText.innerHTML = `🚚 Add <b>${nikkahFormatMoney(diff)}</b> more for Free Delivery`;
      }
    }
  }
}

function submitBundle() {
  let btn = document.getElementById('add-to-cart-btn');
  if(!btn) btn = document.querySelector('.rb-checkout-btn');
  
  if(btn) { btn.innerText = "Processing..."; btn.disabled = true; }
  
  let itemsToAdd = nikkahBundleItems.map(item => {
    let props = { "_Bundle": "Custom Nikkah Package" };
    if(item.requiresFields) {
      if(item.groom) props["Groom"] = item.groom; 
      if(item.bride) props["Bride"] = item.bride;
      if(item.date) props["Date"] = item.date; 
      if(item.note) props["Note"] = item.note;
    }
    return { id: parseInt(item.id), quantity: 1, properties: props };
  });

  fetch(window.Shopify.routes.root + 'cart/add.js', { 
    method: 'POST', 
    headers: { 'Content-Type': 'application/json' }, 
    body: JSON.stringify({ items: itemsToAdd }) 
  })
  .then(r => { 
    if(!r.ok) throw new Error("Error adding to cart"); 
    window.location.href = '/checkout'; 
  })
  .catch(e => { 
    console.error(e);
    alert("Error adding to cart. Please try again."); 
    if(btn) { btn.innerText = "Proceed to Checkout"; btn.disabled = false; } 
  });
}

// --- MOBILE FLOATER SMART SHOW/HIDE ON SCROLL ---
document.addEventListener("DOMContentLoaded", function() {
  let bundleContainer = document.querySelector('.nikkah-bundle-container');
  let mobileFloater = document.querySelector('.rb-mobile-floater');

  if (!bundleContainer || !mobileFloater) return;

  let observerOptions = {
    root: null, // viewport
    threshold: 0.1 // jaise hi 10% section screen par dikhega
  };

  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      // Agar user bundle builder section ke andar hai (upar ya neechay se scroll karke aaya)
      if (entry.isIntersecting) {
        // Sirf tabhi show ho agar cart mein items 0 se zyada hon (optional, ya aap hamesha dikhana chahein)
        mobileFloater.classList.add('bar-visible');
      } else {
        // Jab section se bahir chala jaye toh gayab ho jaye
        mobileFloater.classList.remove('bar-visible');
      }
    });
  }, observerOptions);

  observer.observe(bundleContainer);
});